import Fuse from 'fuse.js'
import type { Card, SealedProduct } from '@/types'

// Threshold picked by testing against the real ~6,700-card catalog: 0.2 still
// tolerates a single-character typo/transposition ("arlogn" -> "Arlong") but
// stays precise for short queries ("arlong" no longer drags in unrelated
// names the way the old 0.35 threshold did). Card text is deliberately NOT
// an indexed key here — fuzzy-matching a short query against long, varied
// ability text at any usable threshold matches almost everything (a classic
// Fuse.js failure mode). card_text search instead uses a plain substring
// check in computeSearchMatch, mirroring the backend's ILIKE fallback.
const FUZZY_NAME_THRESHOLD = 0.2

function buildNameIndex<T>(items: T[]): Fuse<T> {
  return new Fuse(items, {
    keys: ['name'],
    threshold: FUZZY_NAME_THRESHOLD,
    includeScore: true,
    ignoreLocation: true,
  })
}

let cardFuseIndex: Fuse<Card> | null = null
let indexedCards: Card[] | null = null

export function getCardFuseIndex(cards: Card[]): Fuse<Card> {
  if (cardFuseIndex && indexedCards === cards) return cardFuseIndex
  cardFuseIndex = buildNameIndex(cards)
  indexedCards = cards
  return cardFuseIndex
}

let sealedFuseIndex: Fuse<SealedProduct> | null = null
let indexedSealed: SealedProduct[] | null = null

export function getSealedFuseIndex(products: SealedProduct[]): Fuse<SealedProduct> {
  if (sealedFuseIndex && indexedSealed === products) return sealedFuseIndex
  sealedFuseIndex = buildNameIndex(products)
  indexedSealed = products
  return sealedFuseIndex
}
